import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, IconGoogle } from "../../../../components/atoms";
import { InputGroup } from "../../../../components/molecules";
import { AuthContext } from "../../../../contexts/Auth/AuthContext";
import { NotificationContext } from "../../../../contexts/NotificationCTX/NotificationContext";
import { api } from "../../../../helpers";
import { useApi } from "../../../../hooks/useApi";

const theObjectsAreTheSame = (objA: Object, objB: Object) => {
  return JSON.stringify(objA) === JSON.stringify(objB);
};

export function FormEmployeeEdit() {
  const {
    setType,
    setShow,
    setText: setTextAlert,
  } = useContext(NotificationContext);

  const { funcionarioID } = useParams();
  const { getFuncionario } = useApi();

  const { applicationData } = useContext(AuthContext);
  const [campoObrigatorioNome, setcampoObrigatorioNome] =
    useState<boolean>(false);
  const [campoObrigatorioTelefone, setcampoObrigatorioTelefone] =
    useState<boolean>(false);
  const [campoObrigatorioCNPJ, setcampoObrigatorioCNPJ] =
    useState<boolean>(false);
  const [campoObrigatorioCidade, setcampoObrigatorioCidade] =
    useState<boolean>(false);
  const [campoObrigatorioEndereco, setcampoObrigatorioEndereco] =
    useState<boolean>(false);
  const [campoObrigatorioBairro, setcampoObrigatorioBairro] =
    useState<boolean>(false);
  const [campoObrigatorioNumero, setcampoObrigatorioNumero] =
    useState<boolean>(false);

  const [funcionario, setFuncionario] = useState<Funcionario>({
    empresa: 0,
    codigo: 0,
    nome: "",
    telefone: "",
    cpf: "0",
    cidade: "",
    endereco: "",
    bairro: "",
    numero: "",
    email: "",
    cep: "",
    obs: "",
  });

  const gravar = async () => {
    let useredit = applicationData.funcionario;
    const response = await api.post(
      "/api/funcionario/editjson",
      {
        vempresa: funcionario.empresa,
        vcodigo: funcionario.codigo,
        vnome: funcionario.nome,
        vtelefone: funcionario.telefone,
        vcpf: funcionario.cpf,
        vcidade: funcionario.cidade,
        vendereco: funcionario.endereco,
        vbairro: funcionario.bairro,
        vnumero: funcionario.numero,
        vemail: funcionario.email,
        vcep: funcionario.cep,
        vobs: funcionario.obs,
        useredit,
      },
      {
        headers: { Authorization: `Bearer ${applicationData.token}` },
      }
    );
    if (response.status === 200) {
      setType("success");
      setTextAlert(response.statusText);
      setShow(true);
    }
  };

  useEffect(() => {
    (async () => {
      const funcionarioInfo = await getFuncionario(funcionarioID!);
      if (
        funcionarioInfo &&
        !theObjectsAreTheSame(funcionario, funcionarioInfo)
      ) {
        setFuncionario((current: any) => ({ ...current, ...funcionarioInfo }));
      }
    })();
  }, []);

  return (
    <div>
      <h2>Alterar Funcionario</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Nome"
            messageError={campoObrigatorioNome ? "Campo obrigatório!" : ""}
            id="nome"
            type="string"
            value={funcionario.nome}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioNome(true);
              else {
                setFuncionario({ ...funcionario, nome: e.target.value });
                setcampoObrigatorioNome(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="CPF"
            messageError={campoObrigatorioCNPJ ? "Campo obrigatório!" : ""}
            id="cpf"
            type="string"
            value={String(funcionario.cpf)}
            maxLength={11}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioCNPJ(true);
              else {
                setFuncionario({ ...funcionario, cpf: e.target.value });
                setcampoObrigatorioCNPJ(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Telefone"
            messageError={campoObrigatorioTelefone ? "Campo obrigatório!" : ""}
            id="telefone"
            type="string"
            value={String(funcionario.telefone)}
            maxLength={14}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioTelefone(true);
              else {
                setFuncionario({ ...funcionario, telefone: e.target.value });
                setcampoObrigatorioTelefone(false);
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Email"
            id="email"
            type="string"
            value={String(funcionario.email)}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setFuncionario({ ...funcionario, email: e.target.value });
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Endereco"
            messageError={campoObrigatorioEndereco ? "Campo obrigatório!" : ""}
            id="endereco"
            type="string"
            value={String(funcionario.endereco)}
            maxLength={100}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioEndereco(true);
              else {
                setFuncionario({ ...funcionario, endereco: e.target.value });
                setcampoObrigatorioEndereco(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Numero"
            messageError={campoObrigatorioNumero ? "Campo obrigatório!" : ""}
            id="numero"
            type="string"
            value={String(funcionario.numero)}
            maxLength={5}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioNumero(true);
              else {
                setFuncionario({ ...funcionario, numero: e.target.value });
                setcampoObrigatorioNumero(false);
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Bairro"
            messageError={campoObrigatorioBairro ? "Campo obrigatório!" : ""}
            id="bairro"
            type="string"
            value={String(funcionario.bairro)}
            maxLength={40}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioBairro(true);
              else {
                setFuncionario({ ...funcionario, bairro: e.target.value });
                setcampoObrigatorioBairro(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Cep"
            id="cep"
            type="string"
            value={String(funcionario.cep)}
            minLength={8}
            maxLength={8}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setFuncionario({ ...funcionario, cep: e.target.value });
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            value={String(funcionario.cidade)}
            id="cidade"
            messageError={campoObrigatorioCidade ? "Campo obrigatório!" : ""}
            label="Cidade"
            maxLength={40}
            onChange={(e) => {
              if (e.target.value !== "") {
                setFuncionario({ ...funcionario, cidade: e.target.value });
                setcampoObrigatorioCidade(false);
              }
              if (e.target.value === "") setcampoObrigatorioCidade(true);
            }}
          />
        </div>
      </div>

      <div className="row mt-1"></div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-12">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Observacao"
            messageError={campoObrigatorioNome ? "Campo obrigatório!" : ""}
            id="obs"
            type="string"
            value={String(funcionario.obs)}
            maxLength={70}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setFuncionario({ ...funcionario, obs: e.target.value });
            }}
          />
        </div>
      </div>

      <div className="row mt-3"></div>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-2">
          <Button
            appearance="success"
            onClick={() => {
              gravar();
            }}
          >
            Gravar<IconGoogle>save</IconGoogle>
          </Button>
        </div>
      </div>
    </div>
  );
}
